import * as React from 'react';
import React__default, { createContext, useContext } from 'react';
import styled from 'styled-components';
import { pl, pr, p } from '@lendi-ui/spacing';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import getDepth from '@lendi-ui/commons/depth';
import getColour from '@lendi-ui/commons/colours';
import { normalise } from '@lendi-ui/utils';
import getTypography from '@lendi-ui/commons/typography';

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var ItemWrapperBySizeMixin = size => {
  switch (size) {
    case 'sm':
      return "height: 32px;   ".concat(p('sm'), ";");
    case 'md':
      return "height: 40px;   ".concat(p('md'), ";");
    case 'lg':
      return "height: 56px;   ".concat(p('lg'), ";");
    default:
      return undefined;
  }
};
var ItemWrapper = styled.div.withConfig({
  displayName: "indexstyle__ItemWrapper",
  componentId: "lui__sc-18bcxte-0"
})(["background-color:white;", ";width:250px;cursor:pointer;box-sizing:border-box;display:flex;justify-content:flex-start;align-items:center;&:hover{color:", ";background-color:", ";}span{pointer-events:none;}"], props => props.size && ItemWrapperBySizeMixin(props.size), _ref => {
  var {
    theme
  } = _ref;
  return theme.name === 'lendi' ? theme.color.text.inverse : theme.color.text.main;
}, _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.name === 'lendi' ? '#0d5a6d' : theme.color.background.emphasis;
});
var IconWrapper$1 = styled.div.withConfig({
  displayName: "indexstyle__IconWrapper",
  componentId: "lui__sc-18bcxte-1"
})(["", ";", ";line-height:1em;"], pl('sm'), pr('sm'));
var ChildWrapper = styled.div.withConfig({
  displayName: "indexstyle__ChildWrapper",
  componentId: "lui__sc-18bcxte-2"
})(["", ";line-height:1em;"], pl('sm'));

var _excluded$3 = ["size", "icon", "onClick", "children"];
var MenuDropdownItem = _ref => {
  var {
      size = 'md',
      icon,
      onClick = () => {},
      children
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded$3);
  return /*#__PURE__*/jsxs(ItemWrapper, _objectSpread2(_objectSpread2({
    size: size,
    onClick: onClick
  }, otherProps), {}, {
    children: [icon && /*#__PURE__*/jsx(IconWrapper$1, {
      children: icon
    }), children && /*#__PURE__*/jsx(ChildWrapper, {
      children: children
    })]
  }));
};

var ContentWrapper = styled.div.withConfig({
  displayName: "indexstyle__ContentWrapper",
  componentId: "lui__sc-1yqzyyx-0"
})(["position:absolute;display:block;z-index:1;width:250px;overflow:hidden;border-radius:6px;box-shadow:", ";"], getDepth(1));

var Divider = styled.div.withConfig({
  displayName: "indexstyle__Divider",
  componentId: "lui__sc-s5micb-0"
})(["width:250px;height:1px;background-color:", ";"], getColour('shade', 100));

var MenuDropdownDivider = props => {
  return /*#__PURE__*/jsx(Divider, _objectSpread2({}, props));
};

var MenuDropdownContext = /*#__PURE__*/createContext({
  showDropdown: false
});
var useMenuDropdownContext = () => {
  var context = useContext(MenuDropdownContext);
  if (!context) {
    throw new Error("Menu Dropdown context cannot be rendered outside the Menu Dropdown component");
  }
  return context;
};

var _excluded$2 = ["children"];
class MenuDropdownContent extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "renderItem", child => {
      if ( /*#__PURE__*/React.isValidElement(child)) {
        return child;
      }
      return undefined;
    });
  }
  render() {
    var _this$props = this.props,
      {
        children: _children
      } = _this$props,
      otherProps = _objectWithoutProperties(_this$props, _excluded$2);
    return /*#__PURE__*/jsx(MenuDropdownContext.Consumer, {
      children: _ref => {
        var {
          showDropdown
        } = _ref;
        return showDropdown && /*#__PURE__*/jsx(ContentWrapper, _objectSpread2(_objectSpread2({}, otherProps), {}, {
          children: React.Children.map(_children, this.renderItem)
        }));
      }
    });
  }
}
_defineProperty(MenuDropdownContent, "Item", MenuDropdownItem);
_defineProperty(MenuDropdownContent, "Divider", MenuDropdownDivider);

var TriggerWrapper = styled.div.withConfig({
  displayName: "indexstyle__TriggerWrapper",
  componentId: "lui__sc-1mezgx7-0"
})(["height:100%;display:flex;justify-content:space-between;align-items:center;cursor:pointer;:hover{color:", ";background-color:", ";}"], _ref => {
  var {
    theme
  } = _ref;
  return theme.name === 'lendi' ? theme.color.text.inverse : theme.color.text.main;
}, _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.name === 'lendi' ? theme.color.fill.contrast : theme.color.background.emphasis;
});
var IconWrapper = styled.div.withConfig({
  displayName: "indexstyle__IconWrapper",
  componentId: "lui__sc-1mezgx7-1"
})(["", ";", ";line-height:1em;"], pl('sm'), pr('sm'));

var _excluded$1 = ["iconBefore", "iconAfter", "children"];
var MenuDropdownTrigger = _ref => {
  var {
      iconBefore,
      iconAfter,
      children
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded$1);
  return /*#__PURE__*/jsx(TriggerWrapper, _objectSpread2(_objectSpread2({}, otherProps), {}, {
    children: /*#__PURE__*/jsxs(Fragment, {
      children: [iconBefore && /*#__PURE__*/jsx(IconWrapper, {
        children: iconBefore
      }), children, iconAfter && /*#__PURE__*/jsx(IconWrapper, {
        children: iconAfter
      })]
    })
  }));
};

var Wrapper = styled.div.withConfig({
  displayName: "indexstyle__Wrapper",
  componentId: "lui__sc-10omiv5-0"
})(["", ";min-width:45px;min-height:45px;line-height:45px;position:relative;display:inline-block;font-family:", ";"], normalise, getTypography('body1', 'fontFamily'));

var _excluded = ["children"];
class MenuDropdown extends React__default.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "node", /*#__PURE__*/React__default.createRef());
    _defineProperty(this, "state", {
      showDropdown: false
    });
    _defineProperty(this, "handleWindowClick", e => {
      var _this$node$current;
      if ((_this$node$current = this.node.current) !== null && _this$node$current !== void 0 && _this$node$current.contains(e.target)) {
        // on dropdown.
        if (e.target instanceof HTMLDivElement) {
          e.target.click();
        }
        this.handleClick();
      } else {
        // outside
        this.setState({
          showDropdown: false
        });
      }
    });
    _defineProperty(this, "handleClick", () => {
      this.setState({
        showDropdown: !this.state.showDropdown
      });
    });
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.handleWindowClick, false);
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleWindowClick, false);
  }
  render() {
    var _this$props = this.props,
      {
        children
      } = _this$props,
      otherProps = _objectWithoutProperties(_this$props, _excluded);
    return /*#__PURE__*/jsx(Wrapper, _objectSpread2(_objectSpread2({
      ref: this.node
    }, otherProps), {}, {
      children: /*#__PURE__*/jsx(MenuDropdownContext.Provider, {
        value: this.state,
        children: children
      })
    }));
  }
}
_defineProperty(MenuDropdown, "Content", MenuDropdownContent);
_defineProperty(MenuDropdown, "Trigger", MenuDropdownTrigger);

export { MenuDropdown as default, useMenuDropdownContext };
